module.exports = __webpack_public_path__ + "img/callbg.6a536fa7.png";